import apiClient from './apiClient';
import createCrudApi from './createCrudApi';

const feeClient = apiClient('fee');

const feeLevelsApi = createCrudApi(feeClient, 'levels'); // для getAll
const feeDiscountsApi = createCrudApi(feeClient, 'discounts');

const feeApi = {
    feeLevelsApi,
    feeDiscountsApi,

    async createLevel(data) {
        const res = await feeClient.post('level', data);
        return res.data;
    },

    async updateLevel(id, data) {
        const res = await feeClient.put(`level/${id}`, data);
        return res.data;
    },

    async deleteLevel(id) {
        const res = await feeClient.delete(`level/${id}`);
        return res.data;
    },

    async getLevelById(id) {
        const res = await feeClient.get(`level/${id}`);
        return res.data;
    },

    async createDiscount(data) {
        const res = await feeClient.post('discount', data);
        return res.data;
    },

    async updateDiscount(id, data) {
        const res = await feeClient.put(`discount/${id}`, data);
        return res.data;
    },

    async deleteDiscount(id) {
        const res = await feeClient.delete(`discount/${id}`);
        return res.data;
    },

    async getDiscountById(id) {
        const res = await feeClient.get(`discount/${id}`);
        return res.data;
    },

    async calculateFee(promoId, participantsCount) {
        const res = await feeClient.get(`calculate/${promoId}/${participantsCount}`);
        return res.data;
    },
    async calculateFeeGem(promoId, participantsCount) {
        const res = await feeClient.get(`calculate-gem/${promoId}/${participantsCount}`);
        return res.data;
    },
    async getDiscountStatus(promoId) {
        const res = await feeClient.get(`discount-status/${promoId}`);
        return res.data;
    },
};

export default feeApi;
